import { Users } from "lucide-react";
import { UnifiedRecord, SystemMetrics } from "../../../types";
import { OpsOverview } from "../OpsOverview";

interface DashboardProps {
  records: UnifiedRecord[];
  metrics: SystemMetrics | null;
  loading: boolean;
}

export function DeptDashboard({ records, metrics, loading }: DashboardProps) {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-3 mb-4 border-b border-white/10 pb-4">
        <Users className="w-8 h-8 text-teal-400" />
        <div>
          <h2 className="text-xl font-semibold text-white">Department Dashboard</h2>
          <p className="text-gray-400 text-sm">Overview of operations for your department</p>
        </div>
      </div>
      
      {/* Re-use Ops Overview for Department Head */}
      <OpsOverview records={records} metrics={metrics} loading={loading} />
    </div>
  );
}
